<template>
  <div class="extension">
    <el-container>
      <el-header style="height: 100px">

        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_A">
          <div class="security_main_body_div">
            <div class="security_main_body_div_div">
              <div class="security_main_body_div_div_H">奇迹ip推广返佣计划</div>
              <div class="security_main_body_div_div_text">一次推广，永久收益，邀请用户，最高可获得30%佣金返现</div>
            </div>
          </div>

          <div class="extension_butts">
            <div class="extension_butts_div">
              <div @click="tologin" class="extension_butts_div_buttA">马上进入</div>
              <div class="extension_butts_div_buttB" @click="openWeChatChat">联系客服</div>
            </div>
          </div>
        </div>


        <div class="security_main_body_B">
          <div class="security_main_body_B_div">
            <div class="security_main_body_B_div_H">加入奇迹ip推广返佣计划</div>
            <div class="security_main_body_B_div_div">
              <div>
                <div class="card_2">
                  <div class="card">
                    <img src="http://apiupss.ppfly.top/images/ad_icon4.svg" alt="公司2头像" class="avatar">
                    <div class="company-name">佣金提现</div>
                    <div class="company-description">
                      推广获得的佣金直接发放到推广账户，随时随地，申请提现
                    </div>
                  </div>
                  <div class="card">
                    <img src="http://apiupss.ppfly.top/images/ad_icon3.svg" alt="公司3头像" class="avatar">
                    <div class="company-name">30%高额佣金</div>
                    <div class="company-description">
                      推荐用户首次成功购买即可获得30%佣金返现，单笔最高可得5000元
                    </div>
                  </div>
                </div>

                <div class="card_crte">
                  <div class="card_crte_H">多次佣金返现和永久收益</div>
                  <div class="card_crte_divs">
                    <div class="card_crte_divs_A">
                      <div class="card_crte_divs_A_left">
                        <div>
                          <img src="http://apiupss.ppfly.top/images/ad_icon1.svg" alt="">

                        </div>
                        <div class="hdtext">
                          您可获得
                        </div>
                      </div>
                      <div class="card_crte_divs_A_ret">
                        <div>￥{{ onerenjinsum }}</div>
                        <div>一次性现金返佣</div>
                      </div>
                    </div>
                    <div class="card_crte_divs_B">
                      <div class="jiajiandiv">
                        <div class="jiajiandiv_div">
                          假设推荐
                          <div class="counter">
                            <div @click="decrement"> - </div>
                            <div>{{ oneren }}</div>
                            <div @click="increment"> + </div>
                          </div>
                          人注册并试用奇迹ip
                        </div>
                        <div class="jiajiandiv_div">
                          <div class="counter">
                            <div @click="decrementA"> - </div>
                            <div>{{ onerenA }}</div>
                            <div @click="incrementA"> + </div>
                          </div>
                          人首购
                          50G
                          动态包月套餐
                        </div>
                        <div class="jiajiandiv_div">
                          <div class="counter">
                            <div @click="decrementB"> - </div>
                            <div>{{ onerenB }}</div>
                            <div @click="incrementB"> + </div>
                          </div>
                          人复购
                          100G
                          动态包月套餐
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card_2">
                  <div class="card">
                    <img src="http://apiupss.ppfly.top/images/ad_icon1.svg" alt="公司2头像" class="avatar">
                    <div class="company-name">￥3/位注册佣金</div>
                    <div class="company-description">
                      每成功推荐一位用户注册并试用奇迹ip，可立即获得3元/位的佣金返现
                    </div>
                  </div>
                  <div class="card">
                    <img src="http://apiupss.ppfly.top/images/ad_icon2.svg" alt="公司3头像" class="avatar">
                    <div class="company-name">永久收益</div>
                    <div class="company-description">
                      不止首单，推荐用户未来的每笔付费订单，都能获得5%佣金返现，单笔最高可得1000元
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="security_main_body_C">
          <div class="security_main_body_C_divs">
            <div class="security_main_body_B_div">
              <div class="security_main_body_B_div_H">为什么加入奇迹ip推广计划</div>
              <div class="security_main_body_C_img_div">
                <div><img class="security_main_body_C_img" src="http://apiupss.ppfly.top/images/reason_img2.png"
                    alt=""></div>
                <div class="security_main_body_C_div">
                  <div class="H_top_text">免费试用，让推广更简单</div>
                  <div>
                    推广伙伴可免费试用奇迹ip所有产品，为您的潜在用户选择更适合的产品类型。
                    不仅如此，奇迹ip助力您的每一次推广，您只需简单分享，我们为所有受邀用户提供免费试用，体验奇迹ip的优质服务。
                  </div>
                  <div>
                    <div @click="tologin" class="extension_butts_div_buttA">加入推广</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="security_main_body_D">
          <div class="security_main_body_D_div">
            <div class="H_top_text">奇迹ip的服务质量，您的收益保障</div>
            <div class="flex_div_c">
              <div class="security_main_body_D_div_div">
                <div class="security_main_body_D_divA">

                  <div class="security_main_body_D_divA_div">
                    <div><img class="security_main_body_D_img"
                        src="http://apiupss.ppfly.top/images/attr_icon1.svg" alt=""></div>
                    <div>
                      <div class="security_main_body_D_divA_textA">行业领先</div>
                      <div class="security_main_body_D_divA_textB">企业级全球代理IP服务商，100万+用户信赖选择</div>
                    </div>
                  </div>

                  <div class="security_main_body_D_divA_div">
                    <div><img class="security_main_body_D_img"
                        src="http://apiupss.ppfly.top/images/attr_icon2.svg" alt=""></div>
                    <div>
                      <div class="security_main_body_D_divA_textA">亿级资源</div>
                      <div class="security_main_body_D_divA_textB">庞大的资源池，超过1亿个优质IP覆盖全球220多个国家地区</div>
                    </div>
                  </div>
                </div>

                <div class="security_main_body_D_divA">
                  <div class="security_main_body_D_divA_div">
                    <div><img class="security_main_body_D_img"
                        src="http://apiupss.ppfly.top/images/attr_icon3.svg" alt=""></div>
                    <div>
                      <div class="security_main_body_D_divA_textA">安全合规</div>
                      <div class="security_main_body_D_divA_textB">通过ISO9001&ISO27001信息安全认证标准，满足行业高标准</div>
                    </div>
                  </div>

                  <div class="security_main_body_D_divA_div">
                    <div><img class="security_main_body_D_img"
                        src="http://apiupss.ppfly.top/images/attr_icon4.svg" alt=""></div>
                    <div>
                      <div class="security_main_body_D_divA_textA">工具集成</div>
                      <div class="security_main_body_D_divA_textB">支持与大多数主流的第三方软件进行集成，轻松配置代理，开启业务</div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="security_main_body_E">
          <div class="security_main_body_E_div">
            <div class="security_main_body_E_div_div">
              <div>
                <div class="security_main_body_E_div_divA">加入奇迹ip永久收益</div>
                <div class="security_main_body_E_div_divB">根据您的业务需求量身定制解决方案</div>
              </div>
              <div>
                <div class="security_main_body_E_div_divC">成为渠道合作伙伴</div>
                <div class="security_main_body_E_div_divC">定制推广方案，获取更高收益</div>
                <div class="security_main_body_E_div_divC">推广经理提供支持</div>
              </div>
              <div>
                <img class="erwema" src="http://apiupss.ppfly.top/images/05c393ccfa26c25c0bbd4c80744c413.png" alt="">
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
export default {
  data() {
    return {
      oneren: 0,
      onerenA: 0,
      onerenB: 0,
      onerenjin: 0,
      onerenjinA: 0,
      onerenjinB: 0,
      onerenjinsum: 0,
    }
  },
  components: {
    Head, Footer, Xuanfuret
  },
  mounted() {

  },
  methods: {
    openWeChatChat() {
    },
    tologin() {
      this.$router.push({ path: 'login', query: { name: '李四' } })
    },
    increment() {
      this.oneren++;
      this.onerenjin = (this.oneren * 1)
      this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
    },
    decrement() {
      if (this.oneren > 0) {
        this.oneren--;
        this.onerenjin = this.onerenjin - 1
        this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
      }
    },

    incrementA() {
      this.onerenA++;
      this.onerenjinA = (this.onerenA * 2)
      console.log();

      this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
    },
    decrementA() {
      if (this.onerenA > 0) {
        this.onerenA--;
        this.onerenjinA = this.onerenjinA - 2
        this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
      }
    },


    incrementB() {
      this.onerenB++;
      this.onerenjinB = (this.onerenB * 3)
      this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
    },
    decrementB() {
      if (this.onerenB > 0) {
        this.onerenB--;
        this.onerenjinB = this.onerenjinB - 3
      }
      this.onerenjinsum = this.onerenjin + this.onerenjinA + this.onerenjinB
    },

    onInput(event) {
      const inputValue = parseInt(event.target.value, 10);
      if (!isNaN(inputValue)) {
        this.oneren = inputValue;
      } else {
        this.oneren = 0; // 如果输入无效，重置为 0
      }
    },

    onInputA(event) {
      const inputValue = parseInt(event.target.value, 10);
      if (!isNaN(inputValue)) {
        this.onerenA = inputValue;
      } else {
        this.onerenA = 0; // 如果输入无效，重置为 0
      }
    },


    onInputB(event) {
      const inputValue = parseInt(event.target.value, 10);
      if (!isNaN(inputValue)) {
        this.onerenB = inputValue;
      } else {
        this.onerenB = 0; // 如果输入无效，重置为 0
      }
    },
  },
}

</script>
<style>
.counter {
  display: flex;
  align-items: center;
}

.button {
  background-color: #dce9ff;
  border: none;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
}

.input {
  width: 60px;
  text-align: center;
  border: none;
  /* 无边框 */
  outline: none;
  /* 去掉聚焦时的轮廓 */
  font-size: 16px;
  margin: 0 10px;
  /* 添加左右间距 */
}
</style>
<style>
.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.security_main_body_div_div_H {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 54px;
  color: #0e0b3d;
  line-height: 76px;
  text-align: center;
}

.security_main_body_div_div_text {
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, .72);
  margin-top: 22px;
  margin-bottom: 60px;
  text-align: center;
}

.extension_butts {
  display: flex;
  justify-content: center;
}

.extension_butts_div {
  width: 400px;
  display: flex;
  justify-content: space-between;
}

.extension_butts_div_buttA {
  color: #edf3fc;
  background: #6327d3;
  border: none;
  box-shadow: 1px 3px 8px 0 rgba(7, 62, 128, .53);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  width: 191px;
  height: 54px;
  border-radius: 36px;
  cursor: pointer;
}

.extension_butts_div_buttB {
  background: #f8fafe;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  width: 191px;
  height: 54px;
  border-radius: 36px;
  cursor: pointer;
}

.security_main_body_B {
  margin-top: 200px;
}

.security_main_body_B_div_H {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  line-height: 44px;
  text-align: center;
  position: relative;
  margin: 0 auto;
}

.card {
  background-color: #edf3fc;
  /* 卡片背景颜色 */
  /* 边框 */
  border-radius: 8px;
  /* 圆角 */
  width: 250px;
  /* 卡片宽度 */
  margin: 10px;
  /* 卡片间距 */
  padding: 15px;
  /* 内边距 */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
  /* 阴影效果 */
  text-align: center;
  /* 文本居中 */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-10px);
  /* 鼠标悬浮时向上浮动 */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  /* 增加阴影效果 */
}

.avatar {
  width: 80px;
  /* 头像宽度 */
  height: 80px;
  /* 头像高度 */
  border-radius: 50%;
  /* 圆形头像 */
  margin-bottom: 10px;
  /* 头像与文本间距 */
}

.company-name {
  font-size: 18px;
  /* 公司名称字体大小 */
  font-weight: bold;
  /* 加粗 */
  margin-bottom: 5px;
  /* 名称与简介间距 */
}

.company-description {
  font-size: 14px;
  /* 公司简介字体大小 */
  color: #666;
  /* 简介字体颜色 */
}

.card_2 {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.security_main_body_B_div_div {
  display: flex;
  justify-content: center;
}

.security_main_body_B_div_div>div {
  display: flex;
  justify-content: space-between;
  width: 1200px;
}
.card_crte{
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  padding: 20px;
  border-radius: 15px;
}
.card_crte_divs_A_left {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.card_crte_divs_A_left>img {
  width: 50px;
  text-align: center;
}

.card_crte_divs_A {
  display: flex;
  justify-content: space-between;
}

.card_crte_divs_A_ret {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-left: 50px;
}

.card_crte_divs_A_ret>div:nth-child(2) {
  font-size: 20px;
  color: #ea741e;
  text-align: right;
}

.card_crte_divs_A_ret>div:nth-child(1) {
  font-family: SourceHanSansCN-Medium;
  font-size: 55px;
  color: #1b2336;
  text-align: right;
}

.card_crte_H {
  font-family: SourceHanSansCN-Medium;
  font-size: 30px;
  color: #000;
  line-height: 33px;
  text-align: center;
  margin-top: 70px;
  margin-bottom: 40px;
}

.jiajiandiv {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
}

.jiajiandiv_div {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.counter>div:nth-child(1) {
  line-height: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 20px;
  margin-left: 10px;
}

.counter>div:nth-child(2) {
  line-height: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 20px;
  margin-left: 10px;
  margin-right: 10px;
  color: #41426e;
  width: 80px;
}

.counter>div:nth-child(3) {
  line-height: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 20px;
  padding-top: 2px;
  margin-right: 10px;
}

.card_crte_divs_B {
  border-radius: 25px;
  padding: 10px;
  width: 400px;
}

.security_main_body_C {
  display: flex;
  justify-content: center;
  margin-top: 200px;
}

.security_main_body_C_divs {
  width: 1200px;
}

.security_main_body_C_img {
  width: 586px;
}

.security_main_body_C_img_div {
  display: flex;
  justify-content: space-between;
  margin-top: 200px;
}

.security_main_body_C_div {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 460px;
}


.H_top_text {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #161c2d;
  line-height: 48px;
}

.security_main_body_C_div>div:nth-child(2) {
  font-weight: 400;
  font-size: 18px;
  color: #4f5159;
  line-height: 26px;
  margin-top: 21px;
  text-align: left;
}

.security_main_body_D {
  margin-top: 200px;
}

.security_main_body_D_img {
  width: 64px;
  margin-top: 8px;
}

.flex_div_c {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}

.security_main_body_D_div_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.security_main_body_D_divA {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin-top: 100px;
}

.security_main_body_D_divA_textA {
  font-family: SourceHanSansCN-Medium;
  font-size: 24px;
  color: #0b0a33;
  line-height: 42px;
  text-align: left;
}

.security_main_body_D_divA_textB {
  font-weight: 400;
  font-size: 18px;
  color: #7a7d9c;
  line-height: 30px;
  margin-top: 8px;
  text-align: left;
}

.security_main_body_D_divA_div {
  display: flex;
  justify-content: space-between;
  width: 470px;
}

.security_main_body_E_div {
  display: flex;
  justify-content: center;
}

.security_main_body_E_div_div {
  margin-top: 200px;
  width: 1297px;
  height: 348px;
  display: flex;
  justify-content: space-around;
  background-image: url(http://apiupss.ppfly.top/images/free_serve_bg_1%20%281%29.png);
}
.security_main_body_E_div_div>div{
  margin-top: 120px;
}
.security_main_body_E_div_div>div:nth-child(3){
  margin-top: 80px;
}
.erwema {
  width: 195px;
  border-radius: 15px;
}

.security_main_body_E_div_divA {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 32px;
  color: #edf3fc;
}

.security_main_body_E_div_divB {
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  font-size: 18px;
  color: #edf3fc;
  margin-top: 27px;
}

.security_main_body_E_div_divC {
  width: 240px;
  display: flex;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #edf3fc;
  margin-bottom: 20px;
}


</style>
